<div class="sub-page theme-notFoundPage__bg">
  <div class="sub-page__content" [ngClass]="{ 'sub-page__content--colorSettingsMode': colorSettingsMode }">
    @if (!pageIsNotAvailable) {
      <p class="sub-page__heading theme-notFoundPage__mainImg">404</p>
    }
    @if (pageIsNotAvailable) {
      <p class="btv-icon-loop-not-found theme-notFoundPage__mainImg"></p>
    }

    <p class="sub-page__title theme-notFoundPage__mainTitle">
      {{ pageIsNotAvailable ? lg.availablePage.title : lg.pageNotFound.title }}
    </p>
    <p class="sub-page__descr theme-notFoundPage__descr">
      {{ pageIsNotAvailable ? lg.availablePage.descr : lg.pageNotFound.descr }}
    </p>

    <div class="sub-page__btn">
      <bmcore-button
        [component]="'LinkAsButton'"
        themeBtnClass="theme-btn__notFoundPage"
        title="{{ lg.button.backToHome }}"
        routerPath="/"
      >
      </bmcore-button>
    </div>
  </div>
</div>
